import { render, staticRenderFns } from "./RELConciliacao.vue?vue&type=template&id=fdb524d2&"
import script from "./RELConciliacao.vue?vue&type=script&lang=js&"
export * from "./RELConciliacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports